import { BrowserRouter, Route, Routes } from "react-router-dom";
import { StampHeader } from "./components/StampHeader";
import Story from "./routes/Story";
import Landing from "./routes/Landing";
import Invite from "./routes/Invite";
import { Privacy, Terms } from "./routes/Legal";
import { MissingState } from "./components/States";

// Top-level router. The shipping URL pattern is /q/:code; /invite forwards a
// Circle invite token into the app; /privacy and /terms are the public legal
// pages App Store Connect links to; everything else gets the landing or
// "stamp not recognized" page.

export default function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-parchment text-textPrimary">
        <StampHeader />
        <main>
          <Routes>
            <Route path="/q/:code" element={<Story />} />
            <Route path="/invite" element={<Invite />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/" element={<Landing />} />
            <Route path="*" element={<MissingState code="?" />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}
